import CommuteHeader from "./Header";
import "./index.css";
import { useState } from "react";
import CommuteContents from "./Commute";
import { ShowHide } from "../components/ShowHideCompany";
import FlowNumbersBox from "../components/FlowNumbersBox";
import EPRBox from "../components/EPRBox";
const CommuteComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="commute-container" id="commute-id">
      <CommuteHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        {show && (
          <EPRBox
            businessId={businessId}
            mainBusinessId={mainBusinessId}
            category={"Employee Commute"}
          />
        )}
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 7.1"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && <CommuteContents businessId={businessId} />}
    </div>
  );
};

export default CommuteComponent;
